import type { FC } from 'react';
import { useContext, createContext, cloneElement } from 'react';

import type { ISubscriber } from '../models';

export const DraftContext = createContext<Record<string, unknown>>({});

export const DraftProvider = DraftContext.Provider;

export const DraftSubscriber: FC<ISubscriber> = ({ children, mappedProps }) => {
    const data = useContext(DraftContext);

    const clonedData = Object.keys(mappedProps).reduce(
        (prev, cur) =>
            Object.assign(prev, {
                [cur]: data[mappedProps[cur]],
            }),
        {}
    );

    return cloneElement(children, clonedData);
};
